<template>
  <modal :title="title" :show="showModal" @close="closeModal()" :fullbox="fullBox">
    <div class="content" slot="content">
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(editMessage)">
          <div class="margin-top-l">
            <validation-provider
              name="nome"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                v-if="message && message.message_type == 'EMAIL'"
                class="form-field item group-input "
                :class="{ errors: errors[0] }"
              >
                <div class="margin-top-l">
                  <b>Variáveis:</b> #FIRST_NAME#, #LAST_NAME#, #PHONE#, #EMAIL#
                </div>
                <input
                  type="text"
                  v-model="message.name"
                  placeholder="Assunto do E-MAIL"
                />
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <!-- template -->
            <div class="flex column margin-top-m">
              <div class="flex-1 w100">
                <div class="form-field item group-input ">
                  Tipo de mensagem
                  <select
                    class="input"
                    v-model="message.message_type"
                    :disabled="isEdit"
                  >
                    <option
                      v-for="(v, k) in typeList"
                      :key="k"
                      :value="v.id"
                    >
                      {{ v.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="flex column margin-top-m">
              <div class="flex-1 w100">
                <div class="form-field item group-input ">
                  Ordem da mensagem
                  <select
                    class="input"
                    v-model="message.order"
                  >
                    <option
                      v-for="(v, k) in orderList"
                      :key="k"
                      :value="v.id"
                    >
                      {{ v.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- timer -->
            <div v-if="message.message_type == 'AWAIT'" class="flex column margin-top-m">
              <div class="flex-1 w100">
                <div class="form-field item group-input ">
                  Tempo de espera
                  <select
                    class="input"
                    v-model="message.description"
                  >
                    <option
                      v-for="(v, k) in timeList"
                      :key="k"
                      :value="v.id"
                    >
                      {{ v.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="fullBox" class="flex column margin-top-m" style="min-height: 700px; height: 700px; max-height: 700px;width: 100%;">
              <email-editor ref="emailEditor2" v-on:load="editorLoaded" v-on:ready="editorReady" minHeight="700px" style="min-height: 700px; height: 700px; max-height: 700px;width: 100%;"></email-editor>
            </div>
            <!-- message -->
            <div v-else-if="message.message_type !== 'AWAIT'" class="flex column margin-top-l p-8">
              <div class="form-field item group-input">
                Mensagem:
                <div class="margin-top-s">
                  <textarea
                    v-model="message.description"
                    wrap="off"
                    cols="70"
                    rows="10"
                  ></textarea>
                </div>

              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
    <div class="action" slot="action">
      <div class="flex center">
        <a @click="closeModal()" class="button secondary medium">
          Voltar
        </a>
        <a
          @click="acceptModal()"
          class="button primary medium"
          :class="{ unusual: unusual == 'accept' }"
        >
          {{ isEdit ? "Editar" : "Criar" }}
        </a>
      </div>
    </div>
  </modal>
</template>

<script>

import EmailEditor from '@/components/emailEditor/EmailEditor';

import Modal from "@/components/modal/Modal";

export default {
  name: "modal-new-message",
  props: {
    titleName: {
      required: false,
      default: "Criar Nova Mensagem",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    message: {
      required: true,
      default: Object,
    },
    automation: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    EmailEditor
  },
  data() {
    return {
      showModal: false,
      seenGuide: {},
      title: "",
      typeListAux: [
        { id: 'TEXT', label: 'TEXT' },
        { id: 'TEXT-IA-VOICE', label: 'TEXT-IA-VOICE' },
        { id: 'EMAIL', label: 'EMAIL' },
        { id: 'AWAIT', label: 'AWAIT' },
        { id: 'IMG', label: 'IMG' },
        { id: 'LINK', label: 'LINK' },
      ],
      timeList: [
        { id: '5S', label: '5S' },
        { id: '10S', label: '10S' },
        { id: '30S', label: '30S' },
        { id: '1MIN', label: '1MIN' },
        { id: '5MIN', label: '5MIN' },
        { id: '10MIN', label: '10MIN' },
        { id: '30MIN', label: '30MIN' },
        { id: '60MIN', label: '60MIN' },
        { id: '24H', label: '24H' },
        { id: '48H', label: '48H' },
        { id: '72H', label: '72H' },
      ],
      orderList: Array.from({ length: 200 }, (_, i) => ({ id: i, label: i.toString() })),
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  updated() {
    if (this.isEdit) {
      this.title = "Editar mensagem";
    }
  },
  mounted() {
    this.title = this.titleName;
    if (this.isEdit) {
      this.title = "Editar mensagem";
    }
  },
  computed: {
    typeList() {
      if (this.automation && this.automation.auto_type != 'EMAIL') {
        return this.typeListAux.filter(e => e.id !== 'EMAIL')
      }

      return this.typeListAux
    },
    isEdit() {
      return this.message && this.message.id;
    },
    fullBox() {
      return this.message && this.message.message_type == 'EMAIL'
    },
  },
  methods: {
    acceptModal() {
      if (this.message.message_type=='EMAIL') {
        Promise.all([
          this.saveDesign(),
          this.exportHtml(),
        ])
        .then((result) => {
          this.message.email_json = result[0]
          this.message.description = result[1].html
  
          this.showModal = false;
          this.$emit("accept", this.message);
        })
        .catch(() => {
          console.log('teste')
        })
      } else {
        this.showModal = false;
        this.$emit("accept", this.message);
      }
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
    // called when the editor is created
    editorLoaded() {
      if (!this.message) {
        return
      }

      if (this.message && this.message.message_type === 'EMAIL' && this.message.email_json)  {
        this.$refs.emailEditor2.loadDesign(this.message.email_json);
      }
    },
    // called when the editor has finished loading
    editorReady() {
      console.log('editorReady');
    },
    saveDesign() {
      return new Promise( (resolve) => {
        return this.$refs.emailEditor2.saveDesign((design) => {
          resolve(design)
        })
      });
    },
    exportHtml() {
      return new Promise( (resolve) => {
        return this.$refs.emailEditor2.exportHtml((data) => {
          resolve(data)
        })
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

</style>
